 import React from 'react';
import './SunLight.css';

import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";

import solarImg from "../../assets/solorimg.jpg"; 
import urbanImg from "../../assets/urban.jpg";
import coolingImg from "../../assets/coolingImg.jpg";
import soilImg from "../../assets/soilImg.jpg";
import bioImg from "../../assets/bioImg.jpg";

const SunlightPage = () => {
  return (
    <div className="ecovibe-journal">
      <Navbar />
      <SecondNavbar />

      <header className="journal-hero">
        <div className="hero-overlay">
          <h1>Sunlight: The Golden Engine of Life</h1>
        </div>
      </header>

      <div className="journal-grid">
        <main className="main-content">
          <article className="article-body">
            <h2>The Science of Solar Radiation</h2>
            <p>Sunlight is the primary driver of the Earth's climate system. At Ecovibe, we define solar intensity not merely as a weather condition, but as the fundamental energy source that dictates global biodiversity patterns.</p>
            <img src={solarImg} alt="Solar Radiation" className="featured-img" />
            
            <h2>Photosynthesis & The Energy Web</h2>
            <p>Plants act as the world’s most efficient biological batteries. By converting electromagnetic radiation into chemical energy (glucose), they fuel the entire trophic structure. In Pakistan’s arid landscape, high solar intensity necessitates specific canopy management to prevent critical soil moisture loss.</p>
            
            <h2>Urban Heat Island (UHI) Mechanics</h2>
            <p>Our research indicates that urban centers in Pakistan exhibit a <strong>4-6°C temperature anomaly</strong> compared to rural outskirts. This is driven by <em>Thermal Mass Absorption</em>—concrete structures trapping daytime heat and re-emitting it nocturnally. Without strategic intervention, this cycle significantly accelerates local desertification.</p>
            <img src={urbanImg} alt="Urban Canopy" className="featured-img" />

            <h2>Strategic Canopy Management</h2>
            <p>Ecovibe’s proposed mitigation framework prioritizes 'Urban Cool-Zones'. By integrating indigenous, broad-leaf species into urban planning, we can create micro-climates naturally resistant to solar stress.</p>
          </article>
        </main>

        <aside className="sidebar">
          <div className="sidebar-card">
            <h3>Quick Insights</h3>
            <p>Focus: Ecosystem Awareness</p>
          </div>
        </aside>
      </div>

      <section className="action-plan">
        <h2>Community Action Plan</h2>
        <div className="action-grid">
          <div className="action-card"><h4>Urban Gardening</h4><p>Implementing vertical greening systems.</p></div>
          <div className="action-card"><h4>Citizen Science</h4><p>Logging local intensity data.</p></div>
          <div className="action-card"><h4>Canopy Restoration</h4><p>Seed-bombing initiatives.</p></div>
        </div>
      </section>

      <section className="data-highlight">
        <h3>Ecovibe Impact Metric</h3>
        <p><em>"Strategic expansion of urban canopy cover by 20% is projected to reduce local ground-level heat stress by 3.5°C."</em></p>
      </section>

      <section className="benefits-section">
        <h2>Solar Awareness: Benefits & Tips</h2>
        <div className="benefits-grid">
          <div className="benefit-card"><img src={coolingImg} alt="Natural Cooling" /><h4>Natural Cooling</h4><p>Reduces heat by trapping sunlight.</p></div>
          <div className="benefit-card"><img src={soilImg} alt="Soil Hydration" /><h4>Soil Hydration</h4><p>Vital for our arid regions.</p></div>
          <div className="benefit-card"><img src={bioImg} alt="Biodiversity" /><h4>Biodiversity Boost</h4><p>Attracts local pollinators.</p></div>
        </div>
      </section>

      <section className="journal-challenges">
        <h2>The Challenges: When Sunlight Becomes Stress</h2>
        <ul className="challenges-list">
          <li><strong>Water Scarcity:</strong> High solar exposure accelerates evaporation.</li>
          <li><strong>Agricultural Stress:</strong> Heat waves reduce crop yields.</li>
          <li><strong>Public Health:</strong> Extreme UV radiation risks.</li>
        </ul>
      </section>

      <div className="fact-box">
        <h3>Ecovibe Quick Fact</h3>
        <p>Trees can reduce peak summer temperatures by <strong>2°C to 9°C</strong>!</p>
      </div>

      <Footer />
    </div>
  );
};

export default SunlightPage;